import React, { useState, useEffect } from 'react';
import { 
  Facebook, 
  Twitter, 
  Linkedin, 
  Instagram, 
  Mail, 
  Phone, 
  MapPin,
  Cpu,
  Globe,
  Shield,
  Clock,
  Users,
  ChevronRight,
  Send,
  Heart
} from 'lucide-react';
import { Link } from 'react-router-dom';
import httpClient from '../../Api/axios';

function Footer() {
  const currentYear = new Date().getFullYear();
  const [contactInfo, setContactInfo] = useState({
    phone: '+1 (555) 123-4567',
    email: 'info@kandax.com',
    address: '123 Tech Street, Suite 100, Toronto, ON M5H 2N2',
    working_hours: 'Mon-Fri: 9AM-6PM EST'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setTimeout(() => {
        setSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  const socialIcons = [
    { icon: Facebook, label: 'Facebook', url: '#' },
    { icon: Twitter, label: 'Twitter', url: '#' },
    { icon: Linkedin, label: 'LinkedIn', url: '#' },
    { icon: Instagram, label: 'Instagram', url: '#' },
  ];

  const services = [
    'Web Development',
    'Digital Marketing',
    'Cybersecurity',
    
  ];

  const quickLinks = [
    { label: 'Home', path: '/' },
    { label: 'About Us', path: '/about' },
    { label: 'Portfolio', path: '/portfolio' },
    { label: 'Team', path: '/team' },
    { label: 'Contact', path: '/contact' },

   
  ];

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('Fetching footer data...');
        
        const response = await httpClient.get('/getall__footer');
        
        console.log('API Response:', response);
        console.log('Response data:', response.data);
        
        let footerData = response.data;
        
        if (Array.isArray(footerData) && footerData.length > 0) {
          footerData = footerData[0];
        }
        
        if (footerData && footerData.data) {
          footerData = footerData.data;
        }
        
        if (Array.isArray(footerData) && footerData.length > 0) {
          footerData = footerData[0];
        }
        
        console.log('Processed footer data:', footerData);
        
        if (footerData) {
          setContactInfo({
            phone: footerData.phone || contactInfo.phone,
            email: footerData.email || contactInfo.email,
            address: footerData.address || contactInfo.address,
            working_hours: footerData.working_hours || contactInfo.working_hours
          });
        } else {
          console.warn('No footer data found in response');
          setError('No contact information available');
        }
      } catch (err) {
        console.error('Error fetching contact info:', err);
        console.error('Error details:', err.response?.data || err.message);
        setError(`Failed to load contact information: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchContactInfo();
  }, []);

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-white">
     <div className="container mx-auto px-6 sm:px-8 lg:px-16 py-12">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8 lg:gap-x-16">

          {/* Company Info */}
          <div className="space-y-6">
            <div className="space-y-4">
            <Link to="/" className="flex items-center space-x-3">
  <img
    src="/KANDAX_Canada_Logo.png"
    alt="KANDAX Logo"
    className="h-20 w-20 w-auto object-contain"
  />
  <div>
    <p className="text-sm text-white-400 font-medium">
      Human-Led Technology. Real Accountability.
    </p>
  </div>
</Link>

              <p className="text-gray-400 text-sm leading-relaxed">
                Bridging North American accountability with Indian execution excellence to deliver end-to-end technology solutions.
              </p>
            </div>
            
           
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6 pb-2 border-b border-gray-800">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="flex items-center text-gray-400 hover:text-red-400 transition-colors group"
                  >
                    <ChevronRight className="w-4 h-4 mr-2 text-red-500 opacity-0 group-hover:opacity-100 transition-opacity" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6 pb-2 border-b border-gray-800">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <Link
                    to={`${service.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-')}`}
                    className="flex items-center text-gray-400 hover:text-red-400 transition-colors group"
                  >
                    <ChevronRight className="w-4 h-4 mr-2 text-red-500 opacity-0 group-hover:opacity-100 transition-opacity" />
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info & Newsletter */}
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-bold text-white mb-6 pb-2 border-b border-gray-800">Contact Info</h3>
              
              <div className="space-y-4">
                {/* Phone */}
                <div className="flex items-start space-x-3">
                  <div className="w-10 h-10 rounded-lg bg-red-900/30 flex items-center justify-center flex-shrink-0">
                    <Phone className="w-5 h-5 text-red-400" />
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm">Phone</p>
                    {loading ? (
                      <div className="h-5 w-32 bg-gray-800 animate-pulse rounded mt-1"></div>
                    ) : error ? (
                      <p className="text-red-400 text-sm mt-1">{error}</p>
                    ) : (
                      <p className="text-white font-medium">{contactInfo.phone}</p>
                    )}
                  </div>
                </div>
                
                {/* Email */}
                <div className="flex items-start space-x-3">
                  <div className="w-10 h-10 rounded-lg bg-red-900/30 flex items-center justify-center flex-shrink-0">
                    <Mail className="w-5 h-5 text-red-400" />
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm">Email</p>
                    {loading ? (
                      <div className="h-5 w-40 bg-gray-800 animate-pulse rounded mt-1"></div>
                    ) : error ? (
                      <p className="text-red-400 text-sm mt-1">{error}</p>
                    ) : (
                      <p className="text-white font-medium">{contactInfo.email}</p>
                    )}
                  </div>
                </div>
                
                {/* Address */}
                <div className="flex items-start space-x-3">
                  <div className="w-10 h-10 rounded-lg bg-red-900/30 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5 text-red-400" />
                  </div>
                  <div>
                    <p className="text-gray-400 text-sm">Address</p>
                    {loading ? (
                      <div className="h-10 w-48 bg-gray-800 animate-pulse rounded mt-1"></div>
                    ) : error ? (
                      <p className="text-red-400 text-sm mt-1">{error}</p>
                    ) : (
                      <p className="text-white font-medium text-sm">{contactInfo.address}</p>
                    )}
                  </div>
                </div>
                
                
              </div>
            </div>
            
           
          </div>
        </div>

        {/* Bottom Bar */}
       <div className="border-t border-gray-800 mt-12 pt-8">
  <div className="flex justify-center items-center">
    <div className="text-gray-400 text-sm text-center">
      © {currentYear} KANDAX. All rights reserved.
    </div>
  </div>
</div>

      </div>
    </footer>
  );
}

export default Footer;